import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { EventService } from 'src/app/Service/event.service';
import { PaginationTableService } from '../../shared/pagination/pagination-table/pagination-table.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { NgOption } from '@ng-select/ng-select';
import { FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/Service/auth.service';



@Component({
  selector: 'app-list-cae-user',
  templateUrl: './list-cae-user.component.html',
})

export class ListCaeUserComponent implements OnInit, OnDestroy {

  selectedRows: any[] = [];
  isAllSelected: boolean = false;

  waitFor = false;
  dataInformation = <any>[];
  resetTable = false;
  emptyDataList: boolean = true;
  IsPostBack = false;
  msgDataEmpty: string = "El criterio de búsqueda ingresado no existe.";
  idEntity: string = "0";
  currentUser: any;

  fmFilters = this.fb.group({
    txtSearch: ['']
  });

  syncPerson: boolean = false;

  get f() {
    return this.fmFilters.controls;
  }

  /** Variables of pagination */
  protected totalPages: any[] = [];
  protected currentPage: number = 1;
  totalItems: number;


  constructor(
    private readonly _modalService: NgbModal,
    protected eventService: EventService,
    private readonly _service: CaeUserService,
    private readonly fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    private readonly paginationTableService: PaginationTableService,
    private readonly _config: NgbModalConfig) {
    //Configuración para modal global
    _config.backdrop = 'static';
    _config.keyboard = false;

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

    });


    let syncPersonStorage = localStorage.getItem('syncPerson');
    console.log("syncPerson=>", syncPersonStorage);

    if (syncPersonStorage == null) {
      this.syncPerson = this.currentUser.syncPerson;
      localStorage.setItem('syncPerson', this.syncPerson.toString());
    }
    else {
      this.syncPerson = syncPersonStorage == 'true';
    }

    console.log("this.syncPerson=>", this.syncPerson);


  }



  ngOnInit(): void {
    try {
      this.currentPage = parseInt(localStorage.getItem('currentPage') ?? this.paginationTableService.resetPageCurrent().toString());
      this.onLoadGrid(false);
    } catch (error) {
      console.log('Error: ' + error);
    }
  }

  ngOnDestroy(): void {
    //localStorage.removeItem('syncPerson');
  }














  getParameters(): string {
    let filter = "";
    let searchText = this.fmFilters.get('txtSearch')?.value;
    if (searchText.length > 0) {
      filter = "filter=" + searchText;
    }
    console.log(filter);
    return filter;
  }

  onLoadGrid(isFilterByUser: boolean) {
    this.selectedRows = [];
    this.isAllSelected = false;

    if (isFilterByUser) {
      this.currentPage = this.paginationTableService.resetPageCurrent();
    }

    this.waitFor = true;
    this.eventService.startLoadingData();
    let _parametros = this.getParameters();
    this._service.GetUserCaeList(_parametros, this.currentPage).subscribe({
      next: res => {
        console.log("res=> ", res);

        if (res.ok) {
          this.waitFor = false;
          let resultData = res.body;
          let contentJson = JSON.parse(resultData.content);

          console.log("contentJson=> ", contentJson);
          if (contentJson != null) {
            this.dataInformation = contentJson.records;
            this.totalPages = contentJson.pages;
            this.totalItems = contentJson.total;
            this.resetTable = false;
            localStorage.setItem('isInitLoad', '0');
            this.emptyDataList = contentJson.total == 0;
            this.IsPostBack = true;
          }

        }
        else {

          this.translate.stream('common.error500').subscribe((res: string) => {
            this.eventService.errorMessage(0, res);
          });

        }

        this.eventService.completeLoadingData();
        this.waitFor = false;
      },
      error: error => {
        console.log(error);
        //this._errorS.onValidateErrorCode(error);
        this.eventService.completeLoadingData();
        this.waitFor = false;
      }
    });

  }






  onEditItem(id: string, content: any) {
    this.idEntity = id.toString();
    this._modalService.open(content, { size: 'xl' });
  }



  protected changePage($event: any): void {
    this.currentPage = $event;
    this.onLoadGrid(false);
  }






  removeFilter() {

    this.fmFilters = this.fb.group({
      txtSearch: ['']
    });
    this.onLoadGrid(false);
  }

}
